<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-tipo-conta",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  computed: {
    options() {
      return [
        {
          value: "Conta Corrente",
          text: "Conta Corrente"
        },
        {
          value: "Conta Poupança",
          text: "Conta Poupança"
        }
      ];
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TipoConta.vue